import React, { useState, useEffect } from "react"
import { withRouter } from "react-router-dom"
import { translate } from "react-i18next"
import { connect } from "react-redux"
import compose from "ramda/src/compose"
import _get from "lodash/get"

import Prompt from "shared/components/Prompt"

import { getBlockedProducts } from "services/state/billing/action"
import { func, object } from "prop-types"
import {
  BLOCKED_PRODUCT_NO,
  BLOCKED_PRODUCT_YES,
  HEADER_BUTTON_NOTIFICATION
} from "shared/constants/idsElements"

const NotificationBlockedProduct = ({
  getBlockedProducts,
  products,
  history,
  t
}) => {
  const [blockedProducts, setBlockedProducts] = useState(0)
  const [isOpen, setOpen] = useState(true)

  const onClickYes = () => {
    history.push("/products-plant#blockeds")
  }

  const onClickNo = () => {
    setOpen(false)
  }

  useEffect(() => {
    _get(products, "data", []).length && handleGetBlockedProducts()
  }, [])

  const handleGetBlockedProducts = async () => {
    try {
      const response = await getBlockedProducts()
      if (response && response.payload) {
        setBlockedProducts(response.payload.data)
      }
    } catch (error) {
      console.error("error", error)
    }
  }

  if (!blockedProducts || !isOpen) {
    return null
  }

  return (
    <Prompt
      iconName="Lock"
      idButtonYes={`${HEADER_BUTTON_NOTIFICATION}_${BLOCKED_PRODUCT_YES}`}
      idButtonNo={`${HEADER_BUTTON_NOTIFICATION}_${BLOCKED_PRODUCT_NO}`}
      onClickYes={() => onClickYes()}
      onClickNo={() => onClickNo()}
    >
      {t("MSG_0058", { blockedProducts })}
    </Prompt>
  )
}

NotificationBlockedProduct.propTypes = {
  getBlockedProducts: func.isRequired,
  products: object.isRequired,
  history: object,
  t: func
}

const mapStateToProps = ({ products }) => ({
  products
})

const enhance = compose(
  withRouter,
  translate(),
  connect(mapStateToProps, { getBlockedProducts })
)

export default enhance(NotificationBlockedProduct)



// WEBPACK FOOTER //
// ./src/components/Masthead/components/Notification.js